import DynamicFormFieldPayloadResourceModel from '../../generated/types/model/resource/DynamicFormFieldPayloadResourceModel';

export default class DynamicFormFieldPayloadResourceViewModel extends DynamicFormFieldPayloadResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
